var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import Vue from 'vue';
import Component from 'vue-class-component';
import { Talent } from 'packages/talent/entities/Talent';
import { container } from 'tsyringe';
import { TalentAttributesRepository } from 'packages/v3/TalentAttributesRepository';
import { namespace, State } from 'vuex-class';
import { Company } from 'packages/company/entities/Company';
import Icon from 'common/UIToolKit/Icon.vue';
import Draggable from 'vuedraggable';
import { User } from 'packages/users/User';
import env from 'config/env';
import JobAttributesEditor from '@/app/components/jobs/JobAttributesEditor.vue';
import ProfileAttributeEditor from '@/app/components/talent_card/views/ProfileAttributeEditor.vue';
var profile = namespace('profile');
var jobsModule = namespace('jobs');
var talentCardModule = namespace('talentCard');
var company = namespace('companyModule');
var ProfileView = /** @class */ (function (_super) {
    __extends(ProfileView, _super);
    function ProfileView() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.attributesRepository = container.resolve(TalentAttributesRepository);
        _this.jobId = null;
        return _this;
    }
    Object.defineProperty(ProfileView.prototype, "attributesKnowledgeBaseUrl", {
        get: function () {
            return this.user.language === 'fi-FI' ?
                env.KNOWLEDGE_BASE.CANDIDATE_ATTRIBUTES.FI :
                env.KNOWLEDGE_BASE.CANDIDATE_ATTRIBUTES.EN;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ProfileView.prototype, "hasJobContext", {
        get: function () {
            return !!this.$route.params.jobId;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ProfileView.prototype, "availableNewAttributes", {
        get: function () {
            var _this = this;
            return this.availableAttributes.filter(function (attribute) { return !_this.talent.attributes.some(function (existingAttribute) { return existingAttribute.id === attribute.id; }); });
        },
        enumerable: false,
        configurable: true
    });
    ProfileView.prototype.mounted = function () {
        var _a, _b, _c;
        this.jobId = parseInt((_c = (_b = (_a = this.$router) === null || _a === void 0 ? void 0 : _a.currentRoute) === null || _b === void 0 ? void 0 : _b.params) === null || _c === void 0 ? void 0 : _c.jobId);
    };
    ProfileView.prototype.deleteAttribute = function (attribute) {
        return __awaiter(this, void 0, void 0, function () {
            var _a;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        this.talent.attributes = this.talent.attributes.filter(function (attr) { return attr.id !== attribute.id; });
                        _a = this.talent;
                        return [4 /*yield*/, this.attributesRepository.deleteForTalent(this.talent.id, attribute.id, this.jobId)];
                    case 1:
                        _a.score = _b.sent();
                        if (!this.hasJobContext) return [3 /*break*/, 3];
                        return [4 /*yield*/, this.getCandidatesForJob(this.$route.params.jobId)];
                    case 2:
                        _b.sent();
                        _b.label = 3;
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    ProfileView.prototype.updateAttribute = function (attribute) {
        return __awaiter(this, void 0, void 0, function () {
            var existingAttr, _a;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        existingAttr = this.talent.attributes.find(function (attr) { return attr.id === attribute.id; });
                        if (!existingAttr) {
                            return [2 /*return*/, this.addExistingAttribute(attribute)];
                        }
                        existingAttr.value = attribute.value;
                        _a = this.talent;
                        return [4 /*yield*/, this.attributesRepository.setForTalent(this.talent.id, attribute.id, attribute.value, this.jobId)];
                    case 1:
                        _a.score = _b.sent();
                        if (!this.hasJobContext) return [3 /*break*/, 3];
                        return [4 /*yield*/, this.getCandidatesForJob(this.$route.params.jobId)];
                    case 2:
                        _b.sent();
                        _b.label = 3;
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    ProfileView.prototype.addExistingAttribute = function (attributeToAdd) {
        return __awaiter(this, void 0, void 0, function () {
            var _a;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        this.talent.attributes.push(attributeToAdd);
                        _a = this.talent;
                        return [4 /*yield*/, this.attributesRepository.setForTalent(this.talent.id, attributeToAdd.id, attributeToAdd.value, this.jobId)];
                    case 1:
                        _a.score = _b.sent();
                        if (!this.hasJobContext) return [3 /*break*/, 3];
                        return [4 /*yield*/, this.getCandidatesForJob(this.$route.params.jobId)];
                    case 2:
                        _b.sent();
                        _b.label = 3;
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    var _a, _b, _c;
    __decorate([
        talentCardModule.State,
        __metadata("design:type", typeof (_a = typeof Talent !== "undefined" && Talent) === "function" ? _a : Object)
    ], ProfileView.prototype, "talent", void 0);
    __decorate([
        company.State,
        __metadata("design:type", typeof (_b = typeof Company !== "undefined" && Company) === "function" ? _b : Object)
    ], ProfileView.prototype, "company", void 0);
    __decorate([
        profile.State,
        __metadata("design:type", typeof (_c = typeof User !== "undefined" && User) === "function" ? _c : Object)
    ], ProfileView.prototype, "user", void 0);
    __decorate([
        State('attributes'),
        __metadata("design:type", Array)
    ], ProfileView.prototype, "availableAttributes", void 0);
    __decorate([
        jobsModule.Action,
        __metadata("design:type", Function)
    ], ProfileView.prototype, "getCandidatesForJob", void 0);
    ProfileView = __decorate([
        Component({
            components: {
                ProfileAttributeEditor: ProfileAttributeEditor,
                JobAttributesEditor: JobAttributesEditor,
                Icon: Icon,
                Draggable: Draggable,
            },
        })
    ], ProfileView);
    return ProfileView;
}(Vue));
export default ProfileView;
